(function () {
  function enhanceCarousel(root) {
    if (!root) return;
    const sectionId = root.id.replace('Slideshow-', '');
    const pauseBtn = document.querySelector('.slideshow__pause[data-id="' + sectionId + '"]');
    const slides = Array.from(root.querySelectorAll('.slideshow__slide'));
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Add slide roles/labels without changing content
    slides.forEach((s, i) => {
      if (!s.id) s.id = `slide-${sectionId}-${i+1}`;
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', `${i+1} of ${slides.length}`);
    });

    // Focus mgmt helpers
    function hideFocusables(slide, hidden) {
      slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      slide.querySelectorAll('a, button, [tabindex]').forEach(el => {
        if (hidden) {
          if (!el.hasAttribute('data-a11y-orig-tabindex')) {
            el.setAttribute('data-a11y-orig-tabindex', el.getAttribute('tabindex') || '');
          }
          el.setAttribute('tabindex', '-1');
          el.setAttribute('aria-hidden', 'true');
        } else {
          const orig = el.getAttribute('data-a11y-orig-tabindex');
          if (orig === '' || el.matches('a,button')) el.removeAttribute('tabindex');
          else if (orig !== null) el.setAttribute('tabindex', orig);
          el.removeAttribute('data-a11y-orig-tabindex');
          el.removeAttribute('aria-hidden');
        }
      });
    }

    // Initial pass: if theme already marked slides aria-hidden, honor it.
    (function initialSync() {
      const selected =
        slides.findIndex(s => s.classList.contains('is-selected')) >= 0
          ? slides.findIndex(s => s.classList.contains('is-selected'))
          : 0;
      slides.forEach((s, i) => hideFocusables(s, i !== selected));
    })();

    // Hook Flickity if/when available
    function getFlickity() {
      return root.flickity || root._flickity ||
        (window.jQuery && window.jQuery(root).data && window.jQuery(root).data('flickity')) || null;
    }

    function wire(flk) {
      const syncFromFlk = () => {
        const i = flk.selectedIndex || 0;
        slides.forEach((s, n) => hideFocusables(s, n !== i));
      };
      if (flk.on) flk.on('select', syncFromFlk);
      syncFromFlk();

      // Dots & arrows (names + semantics)
      const dotsWrap = root.querySelector('.flickity-page-dots');
      if (dotsWrap) {
        dotsWrap.setAttribute('role', 'tablist');
        dotsWrap.setAttribute('aria-label', 'Choose slide');
        const items = Array.from(dotsWrap.children);
        items.forEach((li, i) => {
          let btn = li.querySelector('button') || li;
          if (btn.tagName !== 'BUTTON') {
            const b = document.createElement('button');
            b.className = btn.className || 'dot';
            btn.replaceWith(b);
            btn = b;
          }
          btn.type = 'button';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-controls', slides[i].id);
          btn.setAttribute('aria-label', `Go to slide ${i+1}`);
          btn.addEventListener('click', () => flk.select(i));
        });
        const syncDots = () => {
          const idx = flk.selectedIndex || 0;
          dotsWrap.querySelectorAll('button[role="tab"]').forEach((b, i) => {
            b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
            b.setAttribute('tabindex', i === idx ? '0' : '-1');
          });
        };
        syncDots();
        if (flk.on) flk.on('select', syncDots);
      }
      const prev = root.parentElement.querySelector('.flickity-prev-next-button.previous');
      const next = root.parentElement.querySelector('.flickity-prev-next-button.next');
      if (prev) { prev.setAttribute('aria-label', 'Previous slide'); prev.setAttribute('type', 'button'); }
      if (next) { next.setAttribute('aria-label', 'Next slide'); next.setAttribute('type', 'button'); }

      // Pause/Play respects reduced motion
      function pause() {
        if (flk.pausePlayer) flk.pausePlayer();
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-pressed', 'true');
          pauseBtn.setAttribute('aria-label', '{{ "sections.slideshow.play_slideshow" | t }}');
        }
      }
      function play() {
        if (prefersReduced) return;
        if (flk.playPlayer) flk.playPlayer();
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-pressed', 'false');
          pauseBtn.setAttribute('aria-label', '{{ "sections.slideshow.pause_slideshow" | t }}');
        }
      }
      const wantsAuto = root.getAttribute('data-autoplay') === 'true';
      if (!wantsAuto || prefersReduced) pause(); else play();
      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          const pressed = pauseBtn.getAttribute('aria-pressed') === 'true';
          pressed ? play() : pause();
        });
      }
      root.addEventListener('focusin', pause);
      root.addEventListener('mouseenter', pause);
      root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget) && wantsAuto && !prefersReduced) play(); });
      root.addEventListener('mouseleave', () => { if (wantsAuto && !prefersReduced) play(); });
    }

    // Bind when ready (and retry)
    (function bindWhenReady() {
      const bound = getFlickity();
      if (bound) { wire(bound); return; }
      document.addEventListener('DOMContentLoaded', () => { const f = getFlickity(); if (f) wire(f); }, { once: true });
      window.addEventListener('shopify:section:load', () => { const f = getFlickity(); if (f) wire(f); });
      let tries = 0;
      const id = setInterval(() => { const f = getFlickity(); if (f || ++tries > 30) { clearInterval(id); if (f) wire(f); } }, 200);
    })();

    // Watch for any theme changes to aria-hidden and keep tabindex in sync
    const mo = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden' && m.target.classList.contains('slideshow__slide')) {
          const s = m.target;
          hideFocusables(s, s.getAttribute('aria-hidden') === 'true');
        }
      });
    });
    mo.observe(root, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  }

  enhanceCarousel(document.getElementById('Slideshow-{{ section.id }}'));
})();
